<template>
  <div class="feedback">
    <mt-header fixed :title="titleText" class="title">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div>
      <div>
        <div><span>打开微信，扫一扫二维码或添加朋友-公众号-搜索 <span>{{ productName }}</span> 并找到
            <span>{{ productName }}</span>，点击关注，发送问题与客服交流</span></div>
        <img :src="imgPath" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

export default {
  name: 'QrCode',
  props: ['titleText'],
  data() {
    return {
      imgPath: '',
      productName: '',
    };
  },
  mounted() {
    switch (PUBLIC_PRODUCT.toLowerCase().trim()) {
      case 'cxyf':
      case 'cxyfzs':
        this.imgPath = require('@/assets/qrcode-cattle-365.png');
        this.productName = '金牛365';
        break;
      case 'cxpro':
      case 'cxplus':
      case 'cxpluszs':
        this.imgPath = require('@/assets/qrcode-chicken-868.png');
        this.productName = '金鸡868';
        break;
      default:
        this.imgPath = require('@/assets/qrcode-no-img.png');
        this.productName = '公众号';
        break;
    }
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
